import { useEffect } from "react";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";
import { uggGAEvent } from "@ugitgud/legos/components/util/UggGAEventProvider";

export const ARAM_MAYHEM_BANNER_CTA = "aram-mayhem-banner-cta";

interface AramMayhemBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function AramMayhemBanner(props: AramMayhemBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  useEffect(() => {
    uggGAEvent("aram-mayhem-banner-cta-view", utmSource || "unknown");
  }, []);

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames("w-full h-[48px] flex items-center relative overflow-hidden", className)}
      style={{
        backgroundImage: "linear-gradient(140deg, #c050a8 0%, #a8c2f2 22%, #a8c2f2 50%, #d080c8 65%, #ecc8e8 100%)",
        backgroundSize: "max(100%, 1440px) 100%",
        backgroundPosition: "35% center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img
        src="https://static.bigbrain.gg/assets/ugg/cta/aram-mayhem.png"
        alt=""
        className="block sm:hidden absolute top-0 h-[48px] w-auto z-0 right-[-120px] xs:right-[-30px]"
      />

      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-center gap-[12px] xs:gap-[16px] sm:gap-[24px] pl-3 pr-3 md:pl-6 md:pr-4 text-white",
          { "pr-10": onClose },
        )}
      >
        <img
          src="https://static.bigbrain.gg/assets/ugg/cta/aram-mayhem.png"
          alt=""
          className="hidden sm:block h-[48px] w-auto shrink-0 self-end"
        />

        <div className="flex flex-col justify-center shrink-0">
          <span className="font-['Barlow_Condensed'] font-bold text-[18px] uppercase leading-none tracking-wide whitespace-nowrap text-[#9304cc]">
            ARAM: MAYHEM SEASON 2 STATS
          </span>
          <span className="text-[12px] text-purple-200 leading-none mt-[3px] whitespace-nowrap">
            New Tier lists, Augments, &amp; More
          </span>
        </div>

        <div
          className="flex items-center justify-center shrink-0 h-[30px] px-[10px] bg-[#5a1292] border border-[#bcccfe] rounded-[3px] cursor-pointer hover:bg-[#6e17b0] transition-colors shadow-[0px_2px_2px_0px_#00000040]"
          onClick={onUrlClick}
        >
          <span className="font-['Barlow_Condensed'] font-semibold text-white text-[13px] whitespace-nowrap">
            EXPLORE MAYHEM ON U.GG
          </span>
        </div>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]" />
        </div>
      )}
    </div>
  );
}
